<template>
<div class="chapter">
<div class="inner_page">
<h1 class="acknowledgements-title"><a id="page-ix"></a><a href="#/toc#toc-acknowledgements">ACKNOWLEDGMENTS</a></h1>
<p class="noindent">I’d like to thank Patrick McNally for his help with the legal system and Dr. Stewart Perlman, Dr. Jeanne Ballinger, and Dr.
         Peter Jelsma for their help with medical issues. I must extend my apologies to Dr. Perlman as well. He came up with several
         clever ways to do away with someone, none of which, alas, worked out for the book. All exaggerations, fictions, and mistakes
         are, of course, my own.
      </p>
<p>I’d also like to thank Beth Pattillo, who helped pull me out when I got myself stuck in the mud of plot and character. And
         to Larry, who always reminds me there is a way out, even if I swear there isn’t.
      </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgements.vue?f34301e8